import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import servePositionService from '../../services/servePositionService';
import { addNotification } from '../../store/slices/uiSlice';
import './PositionFormModal.css';

const PositionFormModal = ({ position, onClose, onSuccess }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    position_name: '',
    position_name_en: '',
    category: 'general',
    description: '',
    requirements: '',
    is_active: true,
    sort_order: 0
  });
  const [loading, setLoading] = useState(false);

  const categoryOptions = [
    { value: 'leadership', label: '領導層' },
    { value: 'worship', label: '敬拜事工' },
    { value: 'administration', label: '行政事務' },
    { value: 'care', label: '關懷牧養' },
    { value: 'outreach', label: '外展傳道' },
    { value: 'general', label: '一般事奉' }
  ];

  useEffect(() => {
    if (position) {
      setFormData({
        position_name: position.position_name || '',
        position_name_en: position.position_name_en || '',
        category: position.category || 'general',
        description: position.description || '',
        requirements: position.requirements || '',
        is_active: position.is_active !== undefined ? position.is_active : true,
        sort_order: position.sort_order || 0
      });
    }
  }, [position]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.position_name.trim()) {
      dispatch(addNotification({
        type: 'error',
        message: '請輸入崗位名稱'
      }));
      return;
    }

    setLoading(true);
    try {
      if (position) {
        await servePositionService.updatePosition(position.id, formData);
      } else {
        await servePositionService.createPosition(formData);
      }
      onSuccess();
    } catch (error) {
      console.error('Error saving position:', error);
      dispatch(addNotification({
        type: 'error',
        message: position ? '更新崗位失敗' : '新增崗位失敗'
      }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content position-form-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{position ? '編輯崗位' : '新增崗位'}</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-body">
            <div className="form-group">
              <label className="required">崗位名稱（中文）</label>
              <input
                type="text"
                name="position_name"
                value={formData.position_name}
                onChange={handleChange}
                placeholder="例如：區牧、小組長"
                required
              />
            </div>

            <div className="form-group">
              <label>崗位名稱（英文）</label>
              <input
                type="text"
                name="position_name_en"
                value={formData.position_name_en}
                onChange={handleChange}
                placeholder="例如：Zone Manager, Group Leader"
              />
            </div>

            <div className="form-group">
              <label className="required">崗位類別</label>
              <select
                name="category"
                value={formData.category}
                onChange={handleChange}
                required
              >
                {categoryOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>崗位描述</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                rows="3"
                placeholder="描述此崗位的職責和工作內容"
              />
            </div>

            <div className="form-group">
              <label>崗位要求</label>
              <textarea
                name="requirements"
                value={formData.requirements}
                onChange={handleChange}
                rows="3"
                placeholder="描述擔任此崗位所需的條件和資格"
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>排序順序</label>
                <input
                  type="number"
                  name="sort_order"
                  value={formData.sort_order}
                  onChange={handleChange}
                  min="0"
                />
                <small>數字越小排序越前</small>
              </div>

              <div className="form-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="is_active"
                    checked={formData.is_active}
                    onChange={handleChange}
                  />
                  <span>啟用此崗位</span>
                </label>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" onClick={onClose} className="btn-cancel">
              取消
            </button>
            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? '儲存中...' : (position ? '更新' : '新增')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PositionFormModal;
